module.exports = __webpack_public_path__ + "static/people_pop18-e9f9d480f2c22b0b2db2d8a37c0da854.png";